export const videoHover = () => {
	const slides = document.querySelectorAll( 'li.video-item' );

	if (!slides.length) {
		return;
	}
	
	slides.forEach( ( slide ) => {
		let playPromise;

		slide.addEventListener( 'mouseenter', ( {target} ) => {
			const videoWrapper = target.querySelector( 'div.preview > video' );

			if ( videoWrapper )
			{	
				playPromise = videoWrapper.play();
				
				if ( playPromise !== undefined )
				{
					playPromise.then(() => {}).catch((error) => {
						console.error('Ошибка воспроизведения:', error);
					});
				}
			}
		} );

		slide.addEventListener( 'mouseleave', ( {target} ) => {
			const videoWrapper = target.querySelector( 'div.preview > video' );

			 if (playPromise !== undefined) {
				videoWrapper.pause();
			}
		} );
	} );
}